{#if fields.imageSrc}
  <div class="animated-block" bind:this={animatedBlock}
    style:color={fields?.textColour || 'inherit'}
    style:aspect-ratio={fields?.width && fields?.height ? `${fields.width}/${fields.height}` : 'auto'}
  >
    {#if fields.link}
      <a class="link-container" href={fields.link} target={fields?.newTab ? '_blank' : '_self'}>
        <span></span>
      </a>
    {/if}
    <Components.LazyImg src={fields.imageSrc} alt={fields?.alt} />
    {#if fields.textContent}
      <div class="text-content-container {fields?.textPosition || 'bottom'}">
        <div class="text-content" style={`
            ${fields.gradientColour && fields?.textPosition !== 'top' ? `background: linear-gradient(rgba(${hexToRGB(fields.gradientColour)},0), rgba(${hexToRGB(fields.gradientColour)},0.8))` : ''}
            ${fields.gradientColour && fields?.textPosition === 'top' ? `background: linear-gradient(rgba(${hexToRGB(fields.gradientColour)},0.8), rgba(${hexToRGB(fields.gradientColour)},0))` : ''}
          `}>
          {@html fields.textContent}
        </div>
      </div>
    {/if}
  </div>
{:else if isLoggedIn}
  <div class='no-image'>
    <h3>Animated Block</h3>
    <p>Enter edit mode and select this plugin to add an image</p>
  </div>
{/if}

<svelte:window bind:innerWidth={windowWidth} />

<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};
  export const classNames = ['animated-block__plugin']

  export const Components = {
    load: [
      'core/extensions/lazy_img/v1.0.0/LazyImg',
    ],
  }
</script>

<script>

  import { getContext } from 'svelte'

  export let fields = {}

  const platform = getContext('platform')

  let windowWidth

  const isLoggedIn = platform.api.core.isLoggedIn()

  let animatedBlock = null

  function hexToRGB (col) {
    col = col.replace(/^#/, '')

    const bigint = parseInt(col, 16)
    const r = (bigint >> 16) & 255
    const g = (bigint >> 8) & 255
    const b = bigint & 255

    return `${r},${g},${b}`
  }

  $: if (fields.responsiveBreakpoint && windowWidth) {
    updateAspectRatio()
  }

  function updateAspectRatio () {
    if (!animatedBlock) { return }

    if (windowWidth < fields.responsiveBreakpoint) {
      animatedBlock.style.aspectRatio = `${fields.responsiveWidth}/${fields.responsiveHeight}`
    } else {
      animatedBlock.style.aspectRatio = `auto`
    }
  }

</script>

<style lang="scss">.no-image {
  width: 100%;
  outline: dashed 2px #888;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 300px;
  padding: 15px;
  box-sizing: border-box;
  text-emphasis: center;
}

.animated-block {
  overflow: hidden;
  position: relative;
  display: block;
  text-align: center;
}
.animated-block .link-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
}
.animated-block .text-content-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.animated-block .text-content-container .text-content {
  padding: 15px;
  min-height: 50%;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
}
.animated-block .text-content-container.top {
  align-items: flex-start;
}
.animated-block .text-content-container.top .text-content {
  justify-content: flex-start;
}
.animated-block .text-content-container.middle {
  align-items: center;
}
.animated-block .text-content-container.middle .text-content {
  justify-content: center;
  min-height: 100%;
}

.animated-block :global(img) {
  transition: 0.3s ease-in-out;
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.animated-block:hover :global(img) {
  transform: scale(1.1);
}</style>
